<script setup>
    import { defineExpose, defineEmits, ref, inject } from 'vue';
    import { useConsultationWebStore } from '@/stores/consultation/consultationWebStore';
    import { WebdtlResponce } from '@/models/consultationWebModel';
    import { getCurrentInstance } from 'vue';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import Utils from '@/commonProject/helpers/utils.js';
    import i18n from '@/common/i18n';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    import { useRoute } from 'vue-router';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');
    // web相談ストア
    const consultationWebStore = useConsultationWebStore();
    // Web相談詳細情報レスポンス
    const webdtlResponce = ref({});
    // セレクトボックス内容
    let tmsRegistrationIssue1 = ref([]);
    let tmsRegistrationIssue2 = ref([]);
    let tmsRegistrationIssue3 = ref([]);
    // Web相談登録入力(Tms型)アンケート内容情報レスポンス
    let webCngTmsFormAttrResponce = ref([]);
    // Web相談登録入力(Tms型)アンケート回答情報レスポンス
    let webCngTmsFormDataResponce = ref([]);
    // Web相談登録入力(Tms型)アンケート回答結果
    let webCngTmsFormAttrAnswer = ref([]);

    // 描画用
    const webCngTmsFormViewModel = ref([]);
    // モーダルフラグ
    const registrationCompleteDispFlg = ref('');
    const registrationApplyTmsDispFlg = ref('');
    const registrationConfirmDispFlg = ref('');

    const languageStore = useLanguageStore();

    const app = getCurrentInstance();

    const route = useRoute();

    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    // 種類を選択し、分類1の生成をせずとも、種類でアンケートフォームが取得できたか判定する。
    const isIssue1HasFormAttrData = ref(false);

    // 種類の絞り込みによる分類1を選択し、分類2の生成をせずとも、種類でアンケートフォームが取得できたか判定する。
    const isIssue2HasFormAttrData = ref(false);

    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    /**
     * 初期処理 親画面から利用可能関数
     * @param WebCngPk Web相談番号
     */
    async function setInfo(WebCngPk) {
        // ストア側詳細情報の初期化
        consultationWebStore.webdtlResponce = {};
        consultationWebStore.tmsRegistrationIssue = [];
        consultationWebStore.webCngTmsFormAttrResponce = [];
        consultationWebStore.webCngTmsFormDataResponce = [];

        // モーダル側で保持しているデータの初期化
        webdtlResponce.value = new WebdtlResponce();
        tmsRegistrationIssue1.value = [];
        tmsRegistrationIssue2.value = [];
        tmsRegistrationIssue3.value = [];
        webCngTmsFormAttrAnswer.value.splice(0);
        webCngTmsFormAttrResponce.value.splice(0);
        webCngTmsFormViewModel.value = [];

        // モーダルフラグ
        registrationApplyTmsDispFlg.value = 'block';
        registrationConfirmDispFlg.value = '';
        registrationCompleteDispFlg.value = '';

        // 一時保存のデータの場合、Web相談番号を設定する。
        webdtlResponce.value.WebCngPk = WebCngPk;

        // Web相談番号が存在する場合
        if (!Utils.isNullEmpty(webdtlResponce.value.WebCngPk)) {
            // Web相談の詳細情報取得
            await getRegistrationInformation(webdtlResponce.value.WebCngPk);

            // アンケート表示
            await getWebCngTmsFormAttr();
        }

        // 初期セレクトボック内容取得
        await getRegistrationTmsInformationIssue();

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalWebConsultationEntryType2 .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    defineExpose({
        setInfo,
    });

    /**
     * Web相談詳細情報取得処理
     * @param WebCngPk Web相談PK
     */
    async function getRegistrationInformation(WebCngPk) {
        const queryParam = {
            Lang: languageStore.getLanguageValue,
            WebCngPk: WebCngPk,
        };
        // Web相談取得APIを実行する。
        const response = await consultationWebStore.getRegistrationInformation(API_URL, queryParam);
        if (response.success) {
            webdtlResponce.value = Object.assign(webdtlResponce.value, consultationWebStore.webdtlResponce);
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * アンケート表示処理
     */
    async function getWebCngTmsFormAttr() {
        // Web相談登録入力(Tms型)アンケート内容
        webCngTmsFormAttrResponce.value = consultationWebStore.webCngTmsFormAttrResponce;

        // Web相談登録入力(Tms型)アンケート一時保存情報
        webCngTmsFormDataResponce.value = consultationWebStore.webCngTmsFormDataResponce;

        // 初期表示時アンケート回答情報作成
        getWebCngTmsFormAttrAnswer();
    }

    /**
     * 初期表示時アンケート回答情報作成処理
     */
    async function getWebCngTmsFormAttrAnswer() {
        // APIから取得したWeb相談アンケートを復元する。
        // アンケート構造が存在するか判定する。
        if (!Utils.isNullEmptyArray(webCngTmsFormAttrResponce.value)) {
            for (const formAttr of webCngTmsFormAttrResponce.value) {
                // プルダウン、チェックボックス、ラジオボタンの選択肢を作成する。
                let ChoicesArr = [];
                if (!Utils.isNullEmptyArray(formAttr.Choices)) {
                    for (const choice of formAttr.Choices) {
                        let obj = {};

                        const index = choice.indexOf(':');

                        // コロンの区切りIDと名称の区切り文字が存在するか判定する。
                        if (index !== -1) {
                            // コロンの区切り文字が存在する場合は、存在する座標が返却される。
                            // 選択肢のID部と名称部を分離する。
                            obj = {
                                id: choice.substr(0, index), // コロンの位置までを抽出しIDとして設定する。
                                name: choice.substr(index + 1), // コロンの座標の次の文字列以降を全て名称として抽出する。
                                value: choice,
                            };
                        } else {
                            // コロンの区切り文字ば存在しない場合は-1が返る。
                            // APIの取得情報をそのまま格納する。
                            obj = {
                                id: choice,
                                name: choice,
                                value: choice,
                            };
                        }

                        // 選択肢の情報を格納する。
                        ChoicesArr.push(obj);
                    }
                }

                const model = {
                    Id: formAttr.Id,
                    No: formAttr.No,
                    Nm: formAttr.Nm,
                    Type: formAttr.Type,
                    Choices: ChoicesArr,
                    Required: formAttr.Required,
                    Explain: formAttr.Explain,
                };

                webCngTmsFormViewModel.value.push(model);

                // 回答用情報の格納フィールドを初期化する。
                let Values = null;

                // 問診票項目の起票内容に応じて、次の通り、画面フォームからの入力内容を格納するモデルを作成する。
                switch (formAttr.Type) {
                    case '01':
                    case '02':
                        // ラジオボックスの場合。
                        // チェックボックスの場合。
                        Values = [];
                        break;
                    default:
                        // 上記以外の場合。
                        // テキストボックスなど。
                        Values = '';
                        break;
                }

                const answerForm = {
                    Id: formAttr.Id,
                    Nm: formAttr.Nm,
                    Type: formAttr.Type,
                    Values: Values,
                    Required: formAttr.Required,
                };

                webCngTmsFormAttrAnswer.value.push(answerForm);
            }

            // ***** 回答データを復元する - ここから - ***** //
            if (!Utils.isNullEmptyArray(webCngTmsFormDataResponce.value)) {
                for (const answeredData of webCngTmsFormDataResponce.value) {
                    for (let j = 0; j < webCngTmsFormAttrAnswer.value.length; j++) {
                        let answerFormModal = webCngTmsFormAttrAnswer.value[j];
                        if (answeredData.Id === answerFormModal.Id) {
                            switch (answerFormModal.Type) {
                                case '02':
                                    if (!Utils.isNullEmptyArray(answeredData.Values)) {
                                        answerFormModal.Values = [];
                                        for (const value of answeredData.Values) {
                                            answerFormModal.Values.push(value);
                                        }
                                    }
                                    break;
                                default:
                                    answerFormModal.Values = '';
                                    answerFormModal.Values = answeredData.Values[0];
                                    break;
                            }
                        }
                    }
                }
            }
            // ***** 回答データを復元する - ここまで - ***** //
        }
    }

    /**
     * アンケート回答情報作成処理
     */
    async function getWebCngTmsFormAttrAnswer2() {
        if (!Utils.isNullEmptyArray(webCngTmsFormAttrResponce.value)) {
            for (const formAttr of webCngTmsFormAttrResponce.value) {
                // プルダウン、チェックボックス、ラジオボタンの選択肢を作成する。
                let ChoicesArr = [];
                if (!Utils.isNullEmptyArray(formAttr.Choices)) {
                    for (const choice of formAttr.Choices) {
                        let obj = {};

                        const index = choice.indexOf(':');

                        // コロンの区切りIDと名称の区切り文字が存在するか判定する。
                        if (index !== -1) {
                            // コロンの区切り文字が存在する場合は、存在する座標が返却される。
                            // 選択肢のID部と名称部を分離する。
                            obj = {
                                id: choice.substr(0, index), // コロンの位置までを抽出しIDとして設定する。
                                name: choice.substr(index + 1), // コロンの座標の次の文字列以降を全て名称として抽出する。
                                value: choice,
                            };
                        } else {
                            // コロンの区切り文字ば存在しない場合は-1が返る。
                            // APIの取得情報をそのまま格納する。
                            obj = {
                                id: choice,
                                name: choice,
                                value: choice,
                            };
                        }

                        // 選択肢の情報を格納する。
                        ChoicesArr.push(obj);
                    }
                }

                const model = {
                    Id: formAttr.Id,
                    No: formAttr.No,
                    Nm: formAttr.Nm,
                    Type: formAttr.Type,
                    Choices: ChoicesArr,
                    Required: formAttr.Required,
                    Explain: formAttr.Explain,
                };

                webCngTmsFormViewModel.value.push(model);
                //B.FormAttr.push(model);

                // 回答用情報の格納フィールドを初期化する。
                let Values = null;

                // 問診票項目の起票内容に応じて、次の通り、画面フォームからの入力内容を格納するモデルを作成する。
                switch (formAttr.Type) {
                    case '01':
                    case '02':
                        // ラジオボックスの場合。
                        // チェックボックスの場合。
                        Values = [];
                        break;
                    default:
                        // 上記以外の場合。
                        // テキストボックスなど。
                        Values = '';
                        break;
                }

                const answerForm = {
                    Id: formAttr.Id,
                    Nm: formAttr.Nm,
                    Type: formAttr.Type,
                    Values: Values,
                    Required: formAttr.Required,
                };

                webCngTmsFormAttrAnswer.value.push(answerForm);
            }
        }
    }

    /**
     * セレクトボックス情報取得処理
     * Web相談TMS相談分類取得APIを実行し、画面の「種類」のプルダウンリストの選選択肢生成する。
     * 「種類」プルダウンの変更イベントで、再度本メソッドを実行し、選択された「種類」の条件で、「分類1」のプルダウンリストの選選択肢生成する。
     * 「分類1」プルダウンの変更イベントで、再度本メソッドを実行し、選択された「分類1」の条件で、「分類2」のプルダウンリストの選選択肢生成する。
     * @param {String} WebCngTmsCatId 選択されているプルダウンの選択肢。
     */
    async function getIssue(WebCngTmsCatId) {
        // リクエストボディを生成。
        let requestBody = {
            Lang: languageStore.getLanguageValue,
        };

        // 「種類」以外のプルダウンは、それぞれの親のプルダウンの選択肢をAPIの条件に設定する。
        if (!Utils.isNullEmpty(WebCngTmsCatId)) {
            requestBody['WebCngTmsCatId'] = WebCngTmsCatId;
        }

        // Web相談TMS相談分類取得APIをコールする。
        const response = await consultationWebStore.getIssue(API_URL, requestBody);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * 初期セレクトボックス取得処理
     */
    async function getRegistrationTmsInformationIssue() {
        // 初期化する。
        tmsRegistrationIssue1.value = [];
        tmsRegistrationIssue2.value = [];
        tmsRegistrationIssue3.value = [];

        // 分類1、分類2のプルダウンの非活性を解除する。
        // 本処理では画面初期表示時なので、プルダウンは活性状態にしておく。
        isIssue1HasFormAttrData.value = false;
        isIssue2HasFormAttrData.value = false;

        // 種類の取得する。条件は全選択肢。
        // Web相談TMS相談分類取得APIを、検索条件を指定せずに実行する。
        await getIssue();
        tmsRegistrationIssue1.value = consultationWebStore.tmsRegistrationIssue;

        // 種類に指定済みのPKがない場合.
        if (Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat1Pk) && tmsRegistrationIssue1.value !== 0) {
            // リストの一番上を選択済みとする。
            webdtlResponce.value.WebCngTmsCat1Pk = tmsRegistrationIssue1.value[0].WebCngTmsCatPk;
            webdtlResponce.value.WebCngTmsCat1Nm = tmsRegistrationIssue1.value[0].WebCngTmsCatNm;

            // ホーム画面のWeb相談の分類が指定されたメニューからの遷移の場合、クエリパラメーター上の初期分類の座標を設定する。
            if (!Utils.isNullEmpty(route.query.cngCat)) {
                // 初期分類の座標を指定して、プルダウンを更新する。
                const cngCat = route.query.cngCat;
                for (const data of tmsRegistrationIssue1.value) {
                    if (data.WebCngTmsCatId === cngCat) {
                        webdtlResponce.value.WebCngTmsCat1Pk = data.WebCngTmsCatPk;
                        webdtlResponce.value.WebCngTmsCat1Nm = data.WebCngTmsCatNm;
                    }
                }
                route.query.cngCat = '';
            }

            // 選択済み種類リスト番号を取得する。
            let selectNum = 0;
            for (let i = 0; i < tmsRegistrationIssue1.value.length; i++) {
                if (tmsRegistrationIssue1.value[i].WebCngTmsCatPk === webdtlResponce.value.WebCngTmsCat1Pk) {
                    break;
                }
                selectNum++;
            }

            // 種類のリストの選択済みデータにアンケートが存在する場合、それを表示してセレクトボックス取得を終了する。
            if (!Utils.isNullEmpty(tmsRegistrationIssue1.value[selectNum].WebCngTmsFormPk)) {
                // Web相談登録入力(Tms型)アンケート内容の取得
                webCngTmsFormAttrResponce.value = tmsRegistrationIssue1.value[selectNum].WebCngTmsFormAttr;

                // フォームPKを設定する。
                webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue1.value[selectNum].WebCngTmsFormPk;

                // アンケート回答情報作成
                getWebCngTmsFormAttrAnswer2();

                // 分類1、分類2のプルダウンを非活性にする。
                isIssue1HasFormAttrData.value = true;
                isIssue2HasFormAttrData.value = true;
                // 種類のリストの一番上にアンケートが存在しない場合、分類1を取得する。
            } else {
                // 分類1の取得
                let issueId;
                for (let i = 0; i < tmsRegistrationIssue1.value.length; i++) {
                    if (webdtlResponce.value.WebCngTmsCat1Pk == tmsRegistrationIssue1.value[i].WebCngTmsCatPk) {
                        issueId = tmsRegistrationIssue1.value[i].WebCngTmsCatId;
                    }
                }
                await getIssue(issueId);
                tmsRegistrationIssue2.value = consultationWebStore.tmsRegistrationIssue;

                if (tmsRegistrationIssue2.value !== 0) {
                    // 分類1のリストの一番上を選択済みとする。
                    webdtlResponce.value.WebCngTmsCat2Pk = tmsRegistrationIssue2.value[0].WebCngTmsCatPk;
                    webdtlResponce.value.WebCngTmsCat2Nm = tmsRegistrationIssue2.value[0].WebCngTmsCatNm;

                    // 分類1のリストの一番上にアンケートが存在する場合、それを表示してセレクトボックス取得を終了する。
                    if (!Utils.isNullEmpty(tmsRegistrationIssue2.value[0].WebCngTmsFormPk)) {
                        // Web相談登録入力(Tms型)アンケート内容の取得
                        webCngTmsFormAttrResponce.value = tmsRegistrationIssue2.value[0].WebCngTmsFormAttr;

                        // フォームPKを設定する。
                        webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue2.value[0].WebCngTmsFormPk;

                        // アンケート回答情報作成
                        getWebCngTmsFormAttrAnswer2();

                        // 分類2のプルダウンを非活性にする。
                        isIssue2HasFormAttrData.value = true;

                        // 分類1のリストの一番上にアンケートが存在しない場合、分類2を取得する。
                    } else {
                        //分類2の取得
                        let issueId;
                        for (let i = 0; i < tmsRegistrationIssue2.value.length; i++) {
                            if (webdtlResponce.value.WebCngTmsCat2Pk == tmsRegistrationIssue2.value[i].WebCngTmsCatPk) {
                                issueId = tmsRegistrationIssue2.value[i].WebCngTmsCatId;
                            }
                        }
                        await getIssue(issueId);
                        tmsRegistrationIssue3.value = consultationWebStore.tmsRegistrationIssue;

                        if (tmsRegistrationIssue3.value !== 0) {
                            // 分類2の一番上を選択済みとする。
                            webdtlResponce.value.WebCngTmsCat3Pk = tmsRegistrationIssue3.value[0].WebCngTmsCatPk;
                            webdtlResponce.value.WebCngTmsCat3Nm = tmsRegistrationIssue3.value[0].WebCngTmsCatNm;

                            // 分類2のリストの一番上にアンケートが存在する場合、それを表示してセレクトボックス取得を終了する。
                            if (!Utils.isNullEmpty(tmsRegistrationIssue3.value[0].WebCngTmsFormPk)) {
                                // Web相談登録入力(Tms型)アンケート内容の取得
                                webCngTmsFormAttrResponce.value = tmsRegistrationIssue3.value[0].WebCngTmsFormAttr;

                                // フォームPKを設定する。
                                webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue3.value[0].WebCngTmsFormPk;

                                // アンケート回答情報作成
                                getWebCngTmsFormAttrAnswer2();
                            }
                        }
                    }
                }
            }
            // 種類に指定済みのPKがある場合、保存済みデータはアンケート作成済みの為、作らないでセレクトボックスを取得
        } else {
            // 分類1の取得
            if (!Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat1Pk)) {
                let issueId;
                for (let i = 0; i < tmsRegistrationIssue1.value.length; i++) {
                    if (webdtlResponce.value.WebCngTmsCat1Pk == tmsRegistrationIssue1.value[i].WebCngTmsCatPk) {
                        issueId = tmsRegistrationIssue1.value[i].WebCngTmsCatId;
                    }
                }
                await getIssue(issueId);
                tmsRegistrationIssue2.value = consultationWebStore.tmsRegistrationIssue;
            }
            //分類2の取得
            if (!Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat2Pk) && Utils.isNullEmpty(tmsRegistrationIssue2.value[0].WebCngTmsFormPk)) {
                let issueId;
                for (let i = 0; i < tmsRegistrationIssue2.value.length; i++) {
                    if (webdtlResponce.value.WebCngTmsCat2Pk == tmsRegistrationIssue2.value[i].WebCngTmsCatPk) {
                        issueId = tmsRegistrationIssue2.value[i].WebCngTmsCatId;
                    }
                }
                await getIssue(issueId);
                tmsRegistrationIssue3.value = consultationWebStore.tmsRegistrationIssue;
            }

            if (Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat2Pk)) {
                // 分類1が存在しないので、分類1のプルダウンの非活性にする。
                isIssue1HasFormAttrData.value = true;
            }

            if (Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat3Pk)) {
                // 分類2が存在しないので、分類2のプルダウンの非活性にする。
                isIssue2HasFormAttrData.value = true;
            }
        }
    }

    /**
     * 種類セレクトボックス内容変更時処理
     */
    async function issue1Change() {
        // 種別以下の表示データクリア
        tmsRegistrationIssue2.value = [];
        tmsRegistrationIssue3.value = [];
        webdtlResponce.value.WebCngTmsCat1Nm = '';
        webdtlResponce.value.WebCngTmsCat2Pk = '';
        webdtlResponce.value.WebCngTmsCat2Nm = '';
        webdtlResponce.value.WebCngTmsCat3Pk = '';
        webdtlResponce.value.WebCngTmsCat3Nm = '';
        webdtlResponce.value.WebCngTmsFormAttr = [];
        webdtlResponce.value.WebCngTmsFormData = [];
        webCngTmsFormAttrAnswer.value = [];
        webCngTmsFormAttrResponce.value = [];
        webCngTmsFormViewModel.value = [];

        // 分類1、分類2のプルダウンの非活性を解除する。
        isIssue1HasFormAttrData.value = false;
        isIssue2HasFormAttrData.value = false;

        //分類1の取得
        let issueId;
        for (let i = 0; i < tmsRegistrationIssue1.value.length; i++) {
            if (webdtlResponce.value.WebCngTmsCat1Pk === tmsRegistrationIssue1.value[i].WebCngTmsCatPk) {
                // TMS相談分類名を設定する。
                webdtlResponce.value.WebCngTmsCat1Nm = tmsRegistrationIssue1.value[i].WebCngTmsCatNm;
                issueId = tmsRegistrationIssue1.value[i].WebCngTmsCatId;

                // 選択した種類にアンケートが存在した場合、アンケートを表示する。
                if (!Utils.isNullEmpty(tmsRegistrationIssue1.value[i].WebCngTmsFormPk)) {
                    // Web相談登録入力(Tms型)アンケート内容の取得
                    webCngTmsFormAttrResponce.value = tmsRegistrationIssue1.value[i].WebCngTmsFormAttr;

                    // フォームPKを設定する。
                    webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue1.value[i].WebCngTmsFormPk;

                    // アンケート回答情報作成
                    getWebCngTmsFormAttrAnswer2();

                    // 種類のプルダウンの選択肢だけで、アンケートフォームを生成できたので、分類1、分類2のプルダウンの非活性にする。
                    isIssue1HasFormAttrData.value = true;
                    isIssue2HasFormAttrData.value = true;

                    // 選択した種類にアンケートが存在しない場合、分類1を取得する。
                } else {
                    await getIssue(issueId);
                    tmsRegistrationIssue2.value = consultationWebStore.tmsRegistrationIssue;

                    if (tmsRegistrationIssue2.value.length !== 0) {
                        // 分類1のリストの一番上を選択済みとする。
                        webdtlResponce.value.WebCngTmsCat2Pk = tmsRegistrationIssue2.value[0].WebCngTmsCatPk;

                        // 分類1セレクトボックス内容変更時処理へ
                        issue2Change();
                    }
                }
                break;
            }
        }
    }

    /**
     * 分類1セレクトボックス内容変更時処理
     */
    async function issue2Change() {
        // 分類1以下の表示データクリア
        tmsRegistrationIssue3.value = [];
        webdtlResponce.value.WebCngTmsCat2Nm = '';
        webdtlResponce.value.WebCngTmsCat3Pk = '';
        webdtlResponce.value.WebCngTmsCat3Nm = '';
        webdtlResponce.value.WebCngTmsFormAttr = [];
        webdtlResponce.value.WebCngTmsFormData = [];
        webCngTmsFormAttrAnswer.value = [];
        webCngTmsFormAttrResponce.value = [];
        webCngTmsFormViewModel.value = [];

        // 分類1、分類2のプルダウンの非活性を解除する。
        isIssue1HasFormAttrData.value = false;
        isIssue2HasFormAttrData.value = false;

        // 分類2の取得
        let issueId;
        for (let i = 0; i < tmsRegistrationIssue2.value.length; i++) {
            if (webdtlResponce.value.WebCngTmsCat2Pk == tmsRegistrationIssue2.value[i].WebCngTmsCatPk) {
                // TMS相談分類名を設定する。
                webdtlResponce.value.WebCngTmsCat2Nm = tmsRegistrationIssue2.value[i].WebCngTmsCatNm;
                issueId = tmsRegistrationIssue2.value[i].WebCngTmsCatId;

                // 選択した分類1にアンケートが存在した場合、アンケートを表示する。
                if (!Utils.isNullEmpty(tmsRegistrationIssue2.value[i].WebCngTmsFormPk)) {
                    // Web相談登録入力(Tms型)アンケート内容の取得
                    webCngTmsFormAttrResponce.value = tmsRegistrationIssue2.value[i].WebCngTmsFormAttr;

                    // フォームPKを設定する。
                    webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue2.value[i].WebCngTmsFormPk;

                    // アンケート回答情報作成
                    getWebCngTmsFormAttrAnswer2();

                    // 種類の選択と、分類1の選択肢で、アンケートフォームが生成できたので、分類2のプルダウンの非活性にする。
                    isIssue2HasFormAttrData.value = true;

                    // 選択した分類1にアンケートが存在しない場合、分類2を取得する。
                } else {
                    await getIssue(issueId);
                    tmsRegistrationIssue3.value = consultationWebStore.tmsRegistrationIssue;

                    if (tmsRegistrationIssue3.value.length !== 0) {
                        // 分類2のリストの一番上を選択済みとする。
                        webdtlResponce.value.WebCngTmsCat3Pk = tmsRegistrationIssue3.value[0].WebCngTmsCatPk;
                        // 分類2セレクトボックス内容変更時処理
                        issue3Change();
                    }
                }
                break;
            }
        }
    }

    /**
     * 分類2セレクトボックス内容変更時処理
     */
    async function issue3Change() {
        // 分類2以下の表示データクリア
        webCngTmsFormAttrAnswer.value = [];
        webCngTmsFormAttrResponce.value = [];
        webCngTmsFormViewModel.value = [];
        webdtlResponce.value.WebCngTmsFormAttr = [];
        webdtlResponce.value.WebCngTmsFormData = [];

        // 分類1、分類2のプルダウンの非活性を解除する。
        isIssue1HasFormAttrData.value = false;
        isIssue2HasFormAttrData.value = false;

        for (let i = 0; i < tmsRegistrationIssue3.value.length; i++) {
            if (webdtlResponce.value.WebCngTmsCat3Pk == tmsRegistrationIssue3.value[i].WebCngTmsCatPk) {
                // TMS相談分類名を設定する。
                webdtlResponce.value.WebCngTmsCat3Nm = tmsRegistrationIssue3.value[i].WebCngTmsCatNm;

                // 選択した分類2にアンケートが存在した場合、アンケートを表示する。
                if (!Utils.isNullEmpty(tmsRegistrationIssue3.value[i].WebCngTmsFormPk)) {
                    // Web相談登録入力(Tms型)アンケート内容の取得
                    webCngTmsFormAttrResponce.value = tmsRegistrationIssue3.value[i].WebCngTmsFormAttr;

                    // フォームPKを設定する。
                    webdtlResponce.value.WebCngTmsFormPk = tmsRegistrationIssue3.value[i].WebCngTmsFormPk;

                    // アンケート回答情報作成
                    getWebCngTmsFormAttrAnswer2();
                }
                break;
            }
        }
    }

    /**
     * Web相談登録入力(TMS型)登録処理
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function registerConsultationWeb(WebCngOpeMode) {
        let requestBody = {
            WebCngOpeMode: WebCngOpeMode,
            WebCngPk: webdtlResponce.value.WebCngPk,
            //NoticeHistPk: webdtlResponce.value.NoticeHistPk,
            WebCngTmsCat1Pk: webdtlResponce.value.WebCngTmsCat1Pk,
            WebCngTmsCat2Pk: webdtlResponce.value.WebCngTmsCat2Pk,
            WebCngTmsCat3Pk: webdtlResponce.value.WebCngTmsCat3Pk,
            WebCngTmsFormPk: webdtlResponce.value.WebCngTmsFormPk,
            WebCngTmsFormData: webdtlResponce.value.WebCngTmsFormData,
        };

        // お知らせ詳細からの遷移の場合、お知らせ送信履歴PKを設定する。
        if (!Utils.isNullEmpty(consultationWebStore.noticeHistPk)) {
            requestBody['NoticeHistPk'] = consultationWebStore.noticeHistPk;
            //webdtlResponce.value.NoticeHistPk = consultationWebStore.noticeHistPk;
            //consultationWebStore.noticeHistPk = '';
        }

        const response = await consultationWebStore.registerConsultationWeb(API_URL, requestBody);
        if (response.success) {
            consultationWebStore.noticeHistPk = '';
            return true;
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                consultationWebStore.noticeHistPk = '';
                location.href = response.redirectUrl;
            }
            return false;
        }
    }

    /**
     * Web相談登録入力(TMS型)「削除」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function deleted(WebCngOpeMode) {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        await registerConsultationWeb(WebCngOpeMode);
        cancelUpdate();
    }

    /**
     * Web相談登録入力(TMS型)「一時保存処理」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function temporaryStorage(WebCngOpeMode) {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }
        
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        // アンケートと相談内容の回答作成を行う。
        await creareAnswers(false);
        await registerConsultationWeb(WebCngOpeMode);
        cancelUpdate();
    }

    /**
     * Web相談登録入力(TMS型)「登録」ボタンのクリックイベント。
     */
    async function nextModal() {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }

        // アンケートと相談内容の回答作成を行う。
        // 登録APIを実行するので、必須チェックを行う。
        const result = await creareAnswers(true);

        // アンケートと相談内容のバリデーションチェックを行った結果、必須チェックの問題が無い場合は、「true」が返る。
        if (result) {
            registrationApplyTmsDispFlg.value = '';
            registrationConfirmDispFlg.value = 'block';
        }
    }

    /**
     * バリデーションチェック
     */
    function isValidationError() {
        // エラーメッセージを初期化する。
        let message = '';

        // 「種別」が選択されているか判定する。
        if (Utils.isNullEmpty(webdtlResponce.value.WebCngTmsCat1Pk)) {
            // 「種別」が選択されていない場合はエラーにする。
            message += i18n.global.t('consultationWebRegistrationApplyTms.message.message1') + '\n';
        }

        // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        if (!Utils.isNullEmpty(message)) {
            // エラーメッセージが存在する場合は、画面に表示する。
            messageDialog('error', message);
            return true;
        }
        return false;
    }

    /**
     * Web相談登録確認モーダル「いいえ」
     */
    async function backModal() {
        registrationApplyTmsDispFlg.value = 'block';
        registrationConfirmDispFlg.value = '';
    }

    /**
     * Web相談登録確認モーダル「はい」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function confirmationOk(WebCngOpeMode) {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        const results = await registerConsultationWeb(WebCngOpeMode);
        if (results) {
            registrationConfirmDispFlg.value = '';
            registrationCompleteDispFlg.value = 'block';
        }
    }

    /**
     * 回答作成
     * @param mode 登録時:true、一時保存時:false
     */
    async function creareAnswers(mode) {
        // Web相談登録入力(Tms型)アンケート回答情報を初期化
        webdtlResponce.value.WebCngTmsFormData.splice(0);

        let message = '';

        for (let i = 0; i < webCngTmsFormAttrAnswer.value.length; i++) {
            let Values = [];
            // 見出しは対象外
            if (webCngTmsFormAttrAnswer.value[i].Type !== '09') {
                if (!Utils.isNullEmpty(webCngTmsFormAttrAnswer.value[i].Values) && Array.isArray(webCngTmsFormAttrAnswer.value[i].Values)) {
                    for (let j = 0; j < webCngTmsFormAttrAnswer.value[i].Values.length; j++) {
                        Values.push(webCngTmsFormAttrAnswer.value[i].Values[j]);
                    }
                } else if (!Utils.isNullEmpty(webCngTmsFormAttrAnswer.value[i].Values)) {
                    Values.push(webCngTmsFormAttrAnswer.value[i].Values);
                }

                // 回答情報バリデーションチェック
                if (mode) {
                    // 回答フォームの各設問の必須設定や、入力文字数などに応じて、バリデーションチェックを行う.
                    // 各設問が必須設定かどうか確認する。
                    if (webCngTmsFormAttrAnswer.value[i].Required) {
                        // 必須の場合。
                        switch (webCngTmsFormAttrAnswer.value[i].Type) {
                            case '01':
                                if (Values.length === 0) {
                                    message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message2') + '\n';
                                }
                                break;
                            case '02':
                                if (Values.length === 0) {
                                    message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message2') + '\n';
                                }
                                break;
                            case '04':
                                if (Values.length === 0) {
                                    message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message3') + '\n';
                                } else {
                                    // テキストボックスで入力されている文字数を判定する。
                                    if (Utils.checkLengthOfString(Values[0])) {
                                        message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message4') + '\n';
                                    }
                                }
                                break;
                            case '05':
                                // テキストエリア
                                if (Values.length === 0) {
                                    message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message3') + '\n';
                                } else {
                                    // テキストエリアで入力されている文字数を判定する。2000文字
                                    if (Utils.checkLengthOfLongString(Values[0])) {
                                        message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message5') + '\n';
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    } else {
                        // 任意の場合。
                        switch (webCngTmsFormAttrAnswer.value[i].Type) {
                            case '04':
                                // テキストボックス
                                if (Values.length !== 0) {
                                    // テキストボックスで入力されている文字数を判定する。
                                    if (Utils.checkLengthOfString(Values[0])) {
                                        message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message4') + '\n';
                                    }
                                }
                                break;
                            case '05':
                                // テキストエリア
                                if (Values.length !== 0) {
                                    // テキストエリアで入力されている文字数を判定する。2000文字。
                                    if (Utils.checkLengthOfLongString(Values[0])) {
                                        message += webCngTmsFormAttrAnswer.value[i].Nm + i18n.global.t('consultationWebRegistrationApplyTms.message.message5') + '\n';
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }

                const FormData = {
                    Id: webCngTmsFormAttrAnswer.value[i].Id,
                    Values: Values,
                };
                webdtlResponce.value.WebCngTmsFormData.push(FormData);
            }
        }

        if (mode) {
            // エラーメッセージが損じする場合は、先に進ませない。
            if (message !== '') {
                messageDialog('error', message);
                return false;
            }
        }

        return true;
    }

    /**
     * 親画面で実装必須関数
     */
    const emit = defineEmits(['registrationApplyTmsModal:cancel', 'registrationApplyTmsModal:regist', 'registrationApplyTmsModal:cancelUpdate']);
    function cancel() {
        // 親画面のキャンセル処理を呼び出す
        emit('registrationApplyTmsModal:cancel');
    }
    function cancelUpdate() {
        // 親画面の更新キャンセル処理を呼び出す
        emit('registrationApplyTmsModal:cancelUpdate');
    }
</script>

<template>
    <article id="modalWebConsultationEntryType2" class="modal" :style="{ display: registrationApplyTmsDispFlg }">
        <!--Web相談登録入力モーダル-->
        <h3>{{ $t('consultationWebRegistrationApplyTms.parts.modalTitle1') }}</h3>
        <section class="modalContents" :class="webdtlResponce.WebCngStatus === '1' ? 'quad' : 'triple'">
            <section class="form">
                <!-- 種類 -->
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyTms.parts.dl1') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <div class="select">
                                    <select v-model="webdtlResponce.WebCngTmsCat1Pk" @change="issue1Change" required>
                                        <option v-for="contents in tmsRegistrationIssue1" :key="contents.WebCngTmsCatPk" :value="contents.WebCngTmsCatPk">
                                            {{ contents.WebCngTmsCatNm }}
                                        </option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- 分類1 -->
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyTms.parts.dl2') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <div class="select">
                                    <select v-model="webdtlResponce.WebCngTmsCat2Pk" @change="issue2Change" required :disabled="isIssue1HasFormAttrData">
                                        <option v-for="contents in tmsRegistrationIssue2" :key="contents.WebCngTmsCatPk" :value="contents.WebCngTmsCatPk">
                                            {{ contents.WebCngTmsCatNm }}
                                        </option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- 分類2 -->
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebRegistrationApplyTms.parts.dl3') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <div class="select">
                                    <select v-model="webdtlResponce.WebCngTmsCat3Pk" @change="issue3Change" required :disabled="isIssue2HasFormAttrData">
                                        <option v-for="contents in tmsRegistrationIssue3" :key="contents.WebCngTmsCatPk" :value="contents.WebCngTmsCatPk">
                                            {{ contents.WebCngTmsCatNm }}
                                        </option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- アンケートと相談内容 -->
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li style="display: inline-block">
                                <label>{{ $t('consultationWebRegistrationApplyTms.parts.dl4') }}</label>
                                
                            </li>
                            <li class="required">
                                <label class="requiredIcon" style="color: #ff0000; font-size: 12px"> *</label>
                                <label class="requiredText" style="font-size: 12px">{{ $t('consultationWebRegistrationApplyTms.parts.dl5') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <table class="servey">
                            <tbody>
                                <tr v-for="(FormAttr, index) in webCngTmsFormViewModel" :key="index">
                                    <template v-if="FormAttr.Type === '09'">
                                        <td>
                                            <!--見出しを生成-->
                                            <span>{{ FormAttr.Nm }}</span>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td>
                                            <span>{{ FormAttr.No }}</span>
                                        </td>
                                        <td>
                                            <span>{{ FormAttr.Nm }}</span>
                                            <span v-if="FormAttr.Required" style="color: #ff0000"> *</span>
                                        </td>
                                        <td>
                                            <template v-if="FormAttr.Type === '01'">
                                                <!--ラジオボタンを生成-->
                                                <ul class="blockInfoBox">
                                                    <li v-for="(data, index2) in FormAttr.Choices" :key="index + '-' + index2">
                                                        <input type="radio" :id="'webregistration-form-radio-' + (index + 1) + '-' + (index2 + 1)" class="radio" :name="'webregistration-form-radioGroup-' + (index + 1)" v-model="webCngTmsFormAttrAnswer[index].Values" :value="data.id" />
                                                        <label class="radio label" :for="'webregistration-form-radio-' + (index + 1) + '-' + (index2 + 1)">{{ data.name }}</label>
                                                    </li>
                                                </ul>
                                            </template>
                                            <template v-else-if="FormAttr.Type === '02'">
                                                <!--チェックボックスを生成-->
                                                <ul class="blockInfoBox">
                                                    <li v-for="(data, index2) in FormAttr.Choices" :key="index + '-' + index2">
                                                        <input type="checkbox" :id="'webregistration-form-checkbox-' + (index + 1) + '-' + (index2 + 1)" class="checkbox" v-model="webCngTmsFormAttrAnswer[index].Values" :value="data.id" />
                                                        <label class="checkbox label" :for="'webregistration-form-checkbox-' + (index + 1) + '-' + (index2 + 1)">{{ data.name }}</label>
                                                    </li>
                                                </ul>
                                            </template>
                                            <template v-else-if="FormAttr.Type === '05'">
                                                <!--テキストエリアを生成-->
                                                <textarea v-model="webCngTmsFormAttrAnswer[index].Values" style="height: 68px" />
                                            </template>
                                            <template v-else-if="FormAttr.Type === '09'">
                                                <!--見出しを生成-->
                                                <span>{{ FormAttr.Nm }}</span>
                                            </template>
                                            <template v-else>
                                                <!--テキストボックスを生成-->
                                                <input type="text" v-model="webCngTmsFormAttrAnswer[index].Values" />
                                            </template>
                                        </td>
                                        <td>
                                            <span>{{ FormAttr.Explain }}</span>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                </dl>
            </section>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center short">
                <li>
                    <button type="button" class="btnNormal" @click="cancel">{{ $t('consultationWebRegistrationApplyTms.parts.modalButton1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" v-if="webdtlResponce.WebCngStatus === '1'" @click="deleted('3')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationApplyTms.parts.modalButton2') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="temporaryStorage('2')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationApplyTms.parts.modalButton3') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="nextModal">{{ $t('common.parts.entry') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalWebConsultationEntryCheck" class="modal small" :style="{ display: registrationConfirmDispFlg }">
        <!--Web相談登録確認モーダル-->
        <p class="textCenter" style="margin-bottom: 20px">{{ $t('consultationWebRegistrationConfirm.parts.modalTitle1') }}</p>
        <p class="textCenter" style="font-size: 16px">{{ $t('consultationWebRegistrationConfirm.parts.modalInformation1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="backModal">{{ $t('consultationWebRegistrationConfirm.parts.modalButton1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="confirmationOk('1')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebRegistrationConfirm.parts.modalButton2') }}</button>
                </li>
            </ul>
        </section>
    </article>

    <article id="modalWebConsultationEntryComplete" class="modal small" :style="{ display: registrationCompleteDispFlg }">
        <!--Web相談登録完了モーダル-->
        <p class="textCenter">{{ $t('consultationWebRegistrationComplete.parts.modalTitle1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="cancelUpdate()">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
<style scoped>
    #overlay .modal .modalContents .form dl dt ul.formLabel {
        display: block;
    }
    #overlay .modal .modalContents .form dl dt ul li.required {
        width: fit-content;
        margin-left: auto;
        top: -6px;
        right: 10px;
    }

    @media screen and (max-width: 1280px) {
        #overlay .modal .modalContents > .form > dl > dt > ul.formLabel > li {
            display: inline-block;
            width: auto;
        }
        #overlay .modal .modalContents > .form > dl > dt > ul.formLabel > li.required {
            top: 0px;
            right: -4px;
        }
    }
</style>
